export interface IWorkspaceToken {
    token: string;
    expiresAt: Date;
}
